const { TelegramClient } = require('messaging-api-telegram');
//const chatId = '-527664197';
const userID = '1196253376';

///AQUÍ SE ENCUENTRA EL USERIDBOT
//https://www.integromat.com/en/help/app/telegram#User%20ID

//CAMBIA LA IMAGEN DE TU BOT
//https://taradevko.com/bots/configure-telegram-chatbot/

//CAMBIA EL NOMBRE DE TU BOT
//https://chatbotslife.com/your-first-telegram-bot-47ea6034d311

const client = new TelegramClient({
  accessToken: '1941048390:AAH5xi9N_3oiRHIPUMKoQboiPqM-DMlpT1k',
  onRequest: ({ method, url, headers, body }) => 
  {
    /* */
  },
});

//https://snyk.io/advisor/npm-package/messaging-api-telegram
//https://namespaceit.com/blog/how-fix-breaking-change-webpack-5-used-to-include-polyfills-for-nodejs-core-modules-by-default-error
/* NOTIFICATION */
export const spotNotificacion = ( name, action, mobile ) => 
{ 
  let message = `spot: ${name}\naction: ${action}\nmobile: ${mobile}`;  

  try 
  {    
    client.sendMessage(userID, message).then(() => {
        console.log('sent');
      }); 
  } 
  catch (error) 
  {
    console.log(error);
  }
}

export const infoNotification = ( action, mobile ) => 
{ 
  let message = `VIVE EN 360\naction: ${action}\nmobile: ${mobile}`;  

  try 
  {    
    client.sendMessage(userID, message).then(() => {
        console.log('sent');
      }); 
  } 
  catch (error) 
  {
    console.log(error);
  }
}